import React from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { type ILanguageState } from '../reducers/language/types';
import RopereLogo from './ropere-logo';

function Footer({ Language }: { Language: ILanguageState }): JSX.Element {
  const {
    languageType: { code: languageCode },
  } = Language;

  return (
    <div className="footer">
      <div className="logo-container">
        <RopereLogo type="large" />
      </div>

      <div className="footer-container">
        <div className="third top-align">
          <p>
            <Trans>layout.ropereIsAPartOfWawahi</Trans>
          </p>
          <p>Wawahi s.r.o.</p>
          <p>Loosova 990/24</p>
          <p>14900 Prague</p>
          <p>Czechia</p>
          <p>ID 05623740</p>
          <p>VATID CZ05623740</p>
          <p>
            <a href="mailto:info@ropere.com">info@ropere.com</a>
          </p>
        </div>

        <div className="third top-align">
          <p className="bold">
            <Trans>layout.weShipGoods</Trans>
          </p>
          <p>
            <Link to={`/${languageCode.toLowerCase()}/reviews`}>
              <Trans>reviews.title</Trans>
            </Link>
          </p>
          <p>
            <Link to={`/${languageCode.toLowerCase()}/delivery`}>
              <Trans>delivery.title</Trans>
            </Link>
          </p>
          <p>
            <Link to={`/${languageCode.toLowerCase()}/terms-and-conditions`}>
              <Trans>termsAndConditions.title</Trans>
            </Link>
          </p>
        </div>

        <div className="third top-align">
          <p>&copy; &reg; Wawahi s.r.o.</p>
          <p>
            <a
              href="https://www.comgate.cz/en"
              target="_blank"
              rel="noreferrer noopener nofollow"
              className="svg-logo"
              aria-label="Comgate"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 259 60"
                width="128"
                height="64"
              >
                <path fill="#fff" d="M1 1h55v55H1Z" />
                <path
                  fill="#ff1616"
                  d="M0 0h60v60H0Zm21.576 22.5c1.183 0 3.252.195 4.828.584l.788-4.772c-1.773-.585-4.138-.877-5.714-.877-7.39 0-10.246 2.63-10.246 8.961v6.331c0 6.234 2.758 8.961 10.246 8.961 1.872 0 4.138-.292 5.714-.876l-.788-4.773a20.45 20.45 0 0 1-4.828.584c-3.448 0-4.433-.974-4.433-3.896V26.3c0-2.825 1.084-3.799 4.433-3.799zm24.828-.974c.788-.195 1.773-.487 2.562-.682v-2.922h-7.291c-1.28-.292-2.66-.487-4.04-.487-6.798 0-9.36 2.922-9.458 7.792v2.143c0 2.825.986 4.968 3.153 6.234-1.182.78-2.463 2.045-2.463 3.993 0 2.922 1.28 4.091 4.63 4.48 3.055.293 4.04.488 6.799.78 1.773.195 2.266.487 2.266 1.85 0 1.56-.986 1.851-5.715 1.851-2.66 0-5.32-.39-7.98-.974l-.69 4.384c2.66.779 6.306 1.168 9.064 1.168 8.867 0 10.64-1.948 10.64-6.915 0-3.312-1.181-5.163-5.024-5.65-2.758-.292-4.138-.487-6.798-.681-.887-.098-1.28-.39-1.28-.974 0-.682.59-1.364 1.379-1.851.492 0 .886.097 1.379.097 6.6 0 9.557-2.824 9.557-7.597v-2.143c.098-1.558-.197-2.922-.69-3.896Zm-4.73 3.896c0-2.24-1.083-3.214-4.039-3.214-2.857 0-3.94 1.071-3.94 3.214v1.753c0 2.338 1.182 3.117 3.94 3.117 2.76 0 4.04-.876 4.04-3.117zm81.632 8.515V27.38c0-5.264-2.488-10.23-11.349-10.23-8.86 0-11.25 4.867-11.25 10.23v6.556c0 5.264 2.39 10.23 11.25 10.23 8.96-.1 11.35-4.966 11.35-10.23zm-6.47-6.754v6.952c0 2.88-1.394 4.47-4.78 4.47-3.384 0-4.778-1.49-4.778-4.47v-6.952c0-2.88 1.394-4.47 4.779-4.47s4.778 1.49 4.778 4.47zm33.45 16.09V25.395c1.991-1.192 5.077-2.185 6.77-2.185 1.493 0 2.09.695 2.09 2.086v18.076h6.471V24.6c0-4.568-1.493-7.647-5.774-7.647-3.086 0-7.367 1.191-10.453 2.78-.797-1.787-2.39-2.78-4.878-2.78-2.987 0-7.069 1.092-10.354 2.681l-.597-2.185h-4.978v25.824h6.47V25.395c2.39-1.192 5.178-2.185 6.77-2.185 1.494 0 2.091.695 2.091 2.086v18.076h6.372zm30.663-7.25c7.168 0 10.354-3.179 10.354-8.443v-2.483c0-1.49-.3-2.88-.896-4.072.896-.298 1.99-.497 2.887-.795v-3.277h-8.064c-1.394-.398-2.887-.497-4.38-.497-7.567 0-10.354 3.278-10.454 8.641v2.483c0 3.178 1.195 5.562 3.484 6.953-1.294.894-2.787 2.284-2.787 4.37 0 3.278 1.493 4.47 5.077 4.966 3.286.397 4.58.497 7.467.894 1.99.199 2.489.497 2.489 2.086 0 1.688-1.095 2.086-6.173 2.086-2.986 0-5.873-.398-8.76-1.093l-.797 4.867c2.887.894 7.068 1.291 10.055 1.291 9.756 0 11.648-2.185 11.648-7.648 0-3.675-1.294-5.76-5.476-6.257-3.086-.298-4.679-.497-7.466-.795-1.095-.1-1.493-.397-1.493-1.092 0-.795.696-1.49 1.493-2.086.697-.1 1.294-.1 1.792-.1zm4.38-10.727v1.986c0 2.483-1.294 3.476-4.38 3.476s-4.38-.993-4.38-3.476v-1.986c0-2.483 1.194-3.576 4.38-3.576s4.38 1.192 4.38 3.576zm30.862.894c0-6.456-2.489-9.337-10.553-9.337-2.887 0-6.371.497-8.86 1.192l.797 4.966c2.29-.496 4.778-.794 7.167-.794 4.082 0 4.978.993 4.978 3.873v2.682h-6.272c-5.276 0-7.566 1.986-7.566 7.25 0 4.47 2.09 7.648 6.77 7.648 2.787 0 5.376-.794 7.765-2.284l.498 1.788h5.376zm-6.47 11.124c-1.494.894-3.187 1.291-4.879 1.291-2.09 0-2.588-.795-2.588-2.582 0-1.987.497-2.583 2.688-2.583h4.778zm25.386.496c-.996.298-2.09.497-3.186.497-1.692 0-2.39-.894-2.39-2.284V22.515h6.273l.398-5.165h-6.67V10l-6.471.894v6.456h-3.783v5.165h3.783v14.401c0 4.57 2.488 6.854 7.168 6.854 1.592 0 4.28-.398 5.674-.993zm9.557-4.072v-1.291H259v-5.562c0-5.562-1.792-10.429-10.155-10.429-8.263 0-10.652 4.569-10.652 10.032v6.853c0 6.158 2.788 9.932 10.951 9.932 3.086 0 6.67-.496 9.557-1.688l-.995-4.867a27.153 27.153 0 0 1-7.965 1.192c-3.982.198-5.077-1.093-5.077-4.172zm0-7.846c0-2.483 1.095-4.172 4.28-4.172 3.187 0 3.983 1.689 3.983 4.172v1.29h-8.263zM91.15 43.77c2.09 0 4.68-.398 6.372-.993l-.797-5.265c-1.792.497-3.584.696-5.376.696-3.783 0-4.778-1.093-4.778-4.271v-7.151c0-3.179 1.095-4.271 4.778-4.271 1.294 0 3.584.198 5.376.695l.797-5.264c-1.892-.596-4.48-.993-6.372-.993-8.163 0-11.15 2.98-11.15 9.932v7.052c0 6.952 2.987 9.833 11.15 9.833z"
                />
              </svg>
            </a>

            {/* <a
              href="https://www.paypal.com/"
              target="_blank"
              rel="noreferrer noopener nofollow"
              className="svg-logo"
              aria-label="PayPal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 16 70 32"
                width="128"
                height="64"
                id="paypal-svg-logo"
              >
                <path
                  fill="#139AD6"
                  d="M49.2 28.2h-3.4c-.2 0-.4.2-.5.4l-1.4 8.8c0 .2.1.3.3.3H46c.2 0 .3-.1.3-.3l.4-2.5c0-.2.2-.4.5-.4h1.1c2.3 0 3.6-1.1 3.9-3.3.2-.9 0-1.7-.4-2.2-.6-.5-1.5-.8-2.6-.8m.4 3.3c-.2 1.2-1.1 1.2-2 1.2H47l.4-2.3c0-.1.1-.2.3-.2h.2c.6 0 1.2 0 1.5.4.2.1.2.4.2.9"
                />
                <path
                  fill="#263B80"
                  d="M24.7 28.2h-3.4c-.2 0-.4.2-.5.4l-1.4 8.8c0 .2.1.3.3.3h1.6c.2 0 .4-.2.5-.4l.4-2.4c0-.2.2-.4.5-.4h1.1c2.3 0 3.6-1.1 3.9-3.3.2-.9 0-1.7-.4-2.2-.6-.5-1.4-.8-2.6-.8m.4 3.3c-.2 1.2-1.1 1.2-2 1.2h-.5l.4-2.3c0-.1.1-.2.3-.2h.2c.6 0 1.2 0 1.5.4.1.1.2.4.1.9M35 31.4h-1.6c-.1 0-.3.1-.3.2l-.1.5-.1-.2c-.4-.5-1.1-.7-1.9-.7-1.8 0-3.4 1.4-3.7 3.3-.2 1 .1 1.9.6 2.5.5.6 1.2.8 2.1.8 1.5 0 2.3-.9 2.3-.9l-.1.5c0 .2.1.3.3.3H34c.2 0 .4-.2.5-.4l.9-5.6c-.1-.1-.3-.3-.4-.3m-2.3 3.2c-.2.9-.9 1.6-1.9 1.6-.5 0-.9-.2-1.1-.4-.2-.3-.3-.7-.3-1.2.1-.9.9-1.6 1.8-1.6.5 0 .8.2 1.1.4.3.3.4.8.4 1.2"
                />
                <path
                  fill="#139AD6"
                  d="M59.4 31.4h-1.6c-.1 0-.3.1-.3.2l-.1.5-.1-.2c-.4-.5-1.1-.7-1.9-.7-1.8 0-3.4 1.4-3.7 3.3-.2 1 .1 1.9.6 2.5.5.6 1.2.8 2.1.8 1.5 0 2.3-.9 2.3-.9l-.1.5c0 .2.1.3.3.3h1.5c.2 0 .4-.2.5-.4l.9-5.6c-.1-.1-.2-.3-.4-.3m-2.3 3.2c-.2.9-.9 1.6-1.9 1.6-.5 0-.9-.2-1.1-.4-.2-.3-.3-.7-.3-1.2.1-.9.9-1.6 1.8-1.6.5 0 .8.2 1.1.4.4.3.5.8.4 1.2"
                />
                <path
                  fill="#263B80"
                  d="M43.7 31.4H42c-.2 0-.3.1-.4.2L39.4 35l-1-3.2c-.1-.2-.2-.3-.5-.3h-1.6c-.2 0-.3.2-.3.4l1.8 5.3-1.7 2.4c-.1.2 0 .5.2.5h1.6c.2 0 .3-.1.4-.2l5.5-7.9c.3-.3.1-.6-.1-.6"
                />
                <path
                  fill="#139AD6"
                  d="m61.3 28.5-1.4 9c0 .2.1.3.3.3h1.4c.2 0 .4-.2.5-.4l1.4-8.8c0-.2-.1-.3-.3-.3h-1.6c-.1-.1-.2 0-.3.2"
                />
                <path
                  fill="#263B80"
                  d="M12 25.2c-.7-.8-2-1.2-3.8-1.2h-5c-.3 0-.6.3-.7.6l-2 13.1c0 .3.2.5.4.5H4l.8-4.9v.2c.1-.3.4-.6.7-.6H7c2.9 0 5.1-1.2 5.8-4.5v-.3c-.1 0-.1 0 0 0 .1-1.3-.1-2.1-.8-2.9"
                />
                <path
                  fill="#139AD6"
                  d="M12.7 28.1v.3c-.7 3.4-2.9 4.5-5.8 4.5H5.4c-.3 0-.6.3-.7.6l-1 6.1c0 .2.1.4.4.4h2.6c.3 0 .6-.2.6-.5v-.1l.5-3.1v-.2c0-.3.3-.5.6-.5h.4c2.5 0 4.5-1 5-4 .2-1.2.1-2.3-.5-3-.1-.2-.3-.4-.6-.5"
                />
                <path
                  fill="#232C65"
                  d="M12 27.8c-.1 0-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.4-.1-.8-.1-1.3-.1H6.2c-.1 0-.2 0-.3.1-.2.1-.3.3-.3.5l-.8 5.2v.2c.1-.3.4-.6.7-.6H7c2.9 0 5.1-1.2 5.8-4.5 0-.1 0-.2.1-.3-.2-.1-.3-.2-.5-.2-.3-.1-.3-.1-.4-.1"
                />
              </svg>
            </a> */}

            <br />

            <svg
              className="svg-logo"
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 24 24"
              id="mastercard-svg-logo"
            >
              <path
                fill="#FF5F00"
                d="M15.245 17.831h-6.49V6.168h6.49v11.663z"
              />
              <path
                fill="#EB001B"
                d="M9.167 12A7.404 7.404 0 0 1 12 6.169 7.417 7.417 0 0 0 0 12a7.417 7.417 0 0 0 11.999 5.831A7.406 7.406 0 0 1 9.167 12z"
              />
              <path
                fill="#F79E1B"
                d="M24 12a7.417 7.417 0 0 1-12 5.831c1.725-1.358 2.833-3.465 2.833-5.831S13.725 7.527 12 6.169A7.417 7.417 0 0 1 24 12z"
              />
            </svg>

            <svg
              className="svg-logo"
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              enableBackground="new 0 0 48 48"
              viewBox="0 0 48 48"
              id="visa"
            >
              <polygon
                fill="#1565c0"
                points="17.202 32.269 21.087 32.269 23.584 16.732 19.422 16.732"
              />
              <path
                fill="#1565c0"
                d="M13.873 16.454l-3.607 11.098-.681-3.126c-1.942-4.717-5.272-6.659-5.272-6.659l3.456 14.224h4.162l5.827-15.538H13.873zM44.948 16.454h-4.162l-6.382 15.538h3.884l.832-2.22h4.994l.555 2.22H48L44.948 16.454zM39.954 26.997l2.22-5.826 1.11 5.826H39.954zM28.855 20.893c0-.832.555-1.665 2.497-1.665 1.387 0 2.775 1.11 2.775 1.11l.832-3.329c0 0-1.942-.832-3.607-.832-4.162 0-6.104 2.22-6.104 4.717 0 4.994 5.549 4.162 5.549 6.659 0 .555-.277 1.387-2.497 1.387s-3.884-.832-3.884-.832l-.555 3.329c0 0 1.387.832 4.162.832 2.497.277 6.382-1.942 6.382-5.272C34.405 23.113 28.855 22.836 28.855 20.893z"
              />
              <path
                fill="#ff9800"
                d="M9.711,25.055l-1.387-6.936c0,0-0.555-1.387-2.22-1.387c-1.665,0-6.104,0-6.104,0
	S8.046,19.229,9.711,25.055z"
              />
            </svg>
          </p>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ Language }) => ({
  Language,
});

export default connect(mapStateToProps)(Footer);

/* <svg
className="svg-logo"
xmlns="http://www.w3.org/2000/svg"
width="64"
height="64"
id="maestro-svg-logo"
>
<path
  fill="#07A9E2"
  fillRule="evenodd"
  d="M32 46c3.8-3.4 6.2-8.4 6.2-14S35.8 21.5 32 18c-3.3-3-7.8-4.9-12.6-4.9C9 13.1.5 21.6.5 32 .5 42.4 9 50.8 19.4 50.8c4.8.1 9.3-1.8 12.6-4.8z"
  clipRule="evenodd"
/>
<path
  fill="#009DDD"
  fillRule="evenodd"
  d="M.5 32C.5 42.4 9 50.8 19.4 50.8c4.9 0 9.3-1.8 12.6-4.9 3.8-3.4 6.2-8.4 6.2-14S35.8 21.5 32 18c-3.3-3-7.8-4.9-12.6-4.9"
  clipRule="evenodd"
/>
<path
  fill="#0284CC"
  fillRule="evenodd"
  d="M32 18c-3.3-3-7.8-4.9-12.6-4.9h-.9C12.6 17.4 8.8 24.3 8.8 32s3.8 14.6 9.6 18.8h.9c4.9 0 9.3-1.8 12.6-4.9 3.8-3.4 6.2-8.4 6.2-14S35.8 21.5 32 18z"
  clipRule="evenodd"
/>
<path
  fill="#FF2957"
  fillRule="evenodd"
  d="M44.7 13.1c-4.9 0-9.3 1.8-12.7 4.9-.7.6-1.3 1.3-1.9 2h3.8c.5.6 1 1.3 1.4 2h-6.7c-.4.7-.8 1.3-1.1 2h8.9c.3.7.6 1.3.8 2H26.8c-.2.7-.4 1.3-.6 2h11.6c.3 1.3.4 2.6.4 4 0 2.1-.3 4.1-1 6H26.8c.2.7.5 1.3.8 2h8.9c-.3.7-.7 1.4-1.1 2h-6.7c.4.7.9 1.4 1.4 2h3.8c-.6.7-1.2 1.4-1.9 2 3.4 3 7.8 4.9 12.7 4.9 10.4 0 18.8-8.4 18.8-18.8 0-10.5-8.4-19-18.8-19z"
  clipRule="evenodd"
/>
<path
  fill="#ED1C2E"
  fillRule="evenodd"
  d="M44.7 13.1c-4.9 0-9.3 1.8-12.7 4.9-.7.6-1.3 1.3-1.9 2h3.8c.5.6 1 1.3 1.4 2h-6.7c-.4.7-.8 1.3-1.1 2h8.9c.3.7.6 1.3.8 2H26.8c-.2.7-.4 1.3-.6 2h11.6c.3 1.3.4 2.6.4 4 0 2.1-.3 4.1-1 6H26.8c.2.7.5 1.3.8 2h8.9c-.3.7-.7 1.4-1.1 2h-6.7c.4.7.9 1.4 1.4 2h3.8c-.6.7-1.2 1.4-1.9 2 3.4 3 7.8 4.9 12.7 4.9 10.4 0 18.8-8.4 18.8-18.8"
  clipRule="evenodd"
/>
<path
  fill="#0466B5"
  fillRule="evenodd"
  d="M32 46c3.8-3.4 6.2-8.4 6.2-14S35.8 21.5 32 18v28z"
  clipRule="evenodd"
/>
<path
  fill="#FFF"
  fillRule="evenodd"
  d="M57 36.1c0-.3.3-.6.6-.6s.6.3.6.6-.3.6-.6.6-.6-.3-.6-.6zm.6.5c.3 0 .4-.2.4-.5s-.2-.4-.4-.4c-.3 0-.5.2-.5.4s.3.5.5.5zm0-.3h-.1v-.5h.3l.1.1c0 .1 0 .1-.1.1l.1.2h-.1l-.1-.2h-.1v.3zm0-.3h.1v-.1h-.1v.1z"
  clipRule="evenodd"
/>
<path
  fill="#D1094B"
  fillRule="evenodd"
  d="M32 18c-.7.6-1.3 1.3-1.9 2h3.8c.5.6 1 1.3 1.4 2h-6.7c-.4.7-.8 1.3-1.1 2h8.9c.3.7.6 1.3.8 2H26.8c-.2.7-.4 1.3-.6 2h11.6c.3 1.3.4 2.6.4 4 0 2.1-.3 4.1-1 6H26.8c.2.7.5 1.3.8 2h8.9c-.3.7-.7 1.4-1.1 2h-6.7c.4.7.9 1.4 1.4 2h3.8c-.6.7-1.2 1.4-1.9 2 3.4 3 7.8 4.9 12.7 4.9h.9c5.8-4.2 9.6-11.1 9.6-18.8 0-7.7-3.8-14.6-9.6-18.8h-.9C39.8 13.1 35.4 15 32 18z"
  clipRule="evenodd"
/>
<path
  fill="#FFF"
  fillRule="evenodd"
  d="M17 36.7h-2.4l1.4-7.3-3.2 7.3h-2.1l-.4-7.3-1.4 7.3H6.8l1.8-9.6h3.7l.2 6 2.6-6h3.8L17 36.7z"
  clipRule="evenodd"
/>
<path
  fill="#DCE5E5"
  fillRule="evenodd"
  d="m14.7 32.5 1.4-3.1-1.1 5.8c.1.5.2 1.1.4 1.6H17l1.8-9.6h-3.5c-.4 1.5-.7 3.2-.7 4.9.1.1.1.2.1.4zM43.2 36.6c-.7.2-1.1.3-1.7.3-1.2 0-1.8-.6-1.8-1.7 0-.2 0-.4.1-.7l.1-.8.1-.6 1.1-5.9h2.3l-.3 1.8h1.2l-.3 1.8h-1.2l-.6 3.2c0 .1-.1.3-.1.3 0 .4.3.6.8.6.3 0 .5 0 .6-.1l-.3 1.8zM50.1 29c-.2-.1-.2-.1-.3-.1-.1 0-.2 0-.2-.1h-.3c-.8 0-1.3.3-2 1.3l.2-1.2h-2.1L44 36.7h2.4c.8-4.8 1.2-5.6 2.3-5.6h.3l.3.1.8-2.2zM33.9 31.4c0 1 .6 1.7 1.8 2.1 1 .4 1.1.5 1.1.9 0 .5-.4.7-1.4.7-.7 0-1.4-.1-2.1-.3l-.3 1.8h.1l.4.1h.6c.6.1 1 .1 1.3.1 2.5 0 3.7-.8 3.7-2.6 0-1.1-.5-1.7-1.7-2.2-1-.4-1.1-.5-1.1-.8 0-.4.4-.6 1.2-.6.4 0 1.1 0 1.7.1l.3-1.8c-.6-.1-1.5-.1-2.1-.1-2.6 0-3.5 1.2-3.5 2.6zM24.6 36.7h-1.9v-.8c-.6.6-1.4.9-2.5.9-1.3 0-2.1-.9-2.1-2.1 0-1.9 1.5-3 4.1-3h1c.1-.3.1-.4.1-.5 0-.5-.4-.7-1.5-.7-.7 0-1.4.1-1.9.2l-.3.1h-.2l.3-1.7c1.2-.3 1.9-.4 2.8-.4 2 0 3.1.8 3.1 2.3 0 .4 0 .7-.2 1.6l-.5 2.8-.1.5-.1.4v.3l-.1.1zm-1.7-3.5h-.5c-1.3 0-2 .4-2 1.2 0 .5.3.8.8.8 1 0 1.7-.8 1.7-2zM32.3 36.5c-.8.2-1.6.3-2.4.3-2.6 0-4-1.2-4-3.5 0-2.7 1.7-4.6 4.1-4.6 1.9 0 3.1 1.1 3.1 2.8 0 .6-.1 1.1-.3 1.9h-4.7v.3c0 .9.7 1.4 2 1.4.9 0 1.6-.1 2.4-.5l-.2 1.9zm-1.2-4.6v-.4c0-.6-.4-1-1.1-1-.7 0-1.3.5-1.5 1.4h2.6z"
  clipRule="evenodd"
/>
<path
  fill="#FFF"
  fillRule="evenodd"
  d="M57.4 33.2c-.4 2.6-2.2 3.7-4.6 3.7-2.6 0-3.7-1.6-3.7-3.6 0-2.7 1.8-4.6 4.6-4.6 2.4 0 3.7 1.6 3.7 3.5v1zm-2.5-1c0-.8-.3-1.5-1.3-1.5-1.2 0-1.9 1.4-1.9 2.7 0 1 .5 1.7 1.3 1.7.5 0 1.6-.7 1.8-1.9.1-.4.1-.7.1-1z"
  clipRule="evenodd"
/>
<path
  fill="#FFF"
  fillRule="evenodd"
  d="M49.2 34.2c.1-.7.2-1.5.2-2.2v-.2c-.1.5-.2 1-.2 1.6-.1.2-.1.5 0 .8z"
  clipRule="evenodd"
/>
</svg> */
